import { PREFERRED_STYLE_CATALOG } from "../constants/PreferredStyles";

export const normalizePreferredStyles = (styles) => {
  if (!Array.isArray(styles)) {
    return [];
  }

  return styles
    .map((style) => {
      if (!style || (typeof style !== 'object' && typeof style !== 'function')) {
        return null;
      }

      const rawId = typeof style.id === 'string' ? style.id.trim() : '';
      const rawLabel = typeof style.label === 'string' ? style.label.trim() : '';
      const aliases = Array.isArray(style.aliases)
        ? style.aliases
            .map((alias) => (typeof alias === 'string' ? alias.trim() : ''))
            .filter(Boolean)
        : [];

      const id = rawId || rawLabel;
      const label = rawLabel || rawId;

      if (!id && !label) {
        return null;
      }

      return {
        id: id || label,
        label: label || id,
        aliases,
      };
    })
    .filter(Boolean);
};

export const FALLBACK_STYLE_OPTIONS = normalizePreferredStyles(PREFERRED_STYLE_CATALOG);
